import { css } from "@emotion/react";

import { appColor } from "./constants/colors";
import { appTypo } from "./constants/typography";

// storybookのためにglobals.cssと合わせなきゃならんぞ。
export const globalStyled = css`
  html {
    font-family: "Roboto", "Noto Sans JP", "Avenir", "Helvetica Neue", "Helvetica", "Arial", "ヒラギノ角ゴ Pro W3",
      "Hiragino Kaku Gothic Pro", "メイリオ", sans-serif;
  }
  body {
    padding: 0;
    margin: 0;
    font-family: "Roboto", sans-serif;
    background-color: #fafafa;
    font-style: normal;
    font-weight: normal;
  }
  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: inherit;
    }
  }

  @media all and (min-width: 600px) and (max-width: 1280px) {
    & .MuiPaper-root {
      border-radius: 8px !important;
    }
  }

  @media all and (max-width: 600px) {
    & .MuiPaper-root {
      border-radius: 16px !important;
    }
  }
  & header.MuiPaper-root {
    border-radius: 0 !important;
    position: fixed !important;
    z-index: 999 !important;
  }

  & .MuiList-root {
    display: block;
    overflow: auto;
    height: 100%;
  }
  .sb-show-main.sb-main-padded {
    padding: 0;
  }
  .firebase-emulator-warning {
    display: none;
  }

  // rsuiteの期間指定のUI
  & .rs-picker-menu {
    z-index: 2022 !important;
  }
  & .rs-picker-popup {
    z-index: 2022 !important;
  }
  & .rs-picker-daterange-menu {
    z-index: 2022 !important;
  }
  & .rs-picker-toggle {
    font-family: ${appTypo.font.roboto} !important;
    font-size: 14px !important;
    color: ${appColor.text.primary} !important;
  }
  & .rs-picker-input-group {
    font-family: ${appTypo.font.roboto} !important;
  }
  & .rs-input-group {
    font-family: ${appTypo.font.roboto} !important;
    font-size: 14px !important;
    color: ${appColor.text.primary} !important;
    background-color: ${appColor.background.primary} !important;

    &:hover {
      border-color: ${appColor.App.primary} !important;
    }

    &:focus,
    &:focus-within,
    &:active {
      border-color: ${appColor.App.primary} !important;
      box-shadow: 0 0 0 2px rgba(64, 150, 123, 0.2) !important;
      outline: none !important;
    }
  }
  & .rs-input-group-md {
    font-family: ${appTypo.font.roboto} !important;
    font-size: 14px !important;
  }
  & .rs-date-range-input {
    font-family: ${appTypo.font.roboto} !important;
    font-size: 14px !important;
    color: ${appColor.text.primary} !important;
    background-color: ${appColor.background.primary} !important;
  }
  & .rs-btn-primary {
    color: ${appColor.App.white} !important;
    background: ${appColor.App.primary} !important;
    &:hover {
      color: ${appColor.App.white} !important;
      background: rgba(64, 150, 123, 0.8) !important;
    }
  }
  & .rs-btn-link {
    color: ${appColor.text.primary} !important;
    &:hover {
      color: ${appColor.App.primary} !important;
    }
    &:focus {
      color: ${appColor.App.primary} !important;
    }
  }
  & .rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
    background-color: ${appColor.App.primary} !important;
  }
  & .rs-calendar-table-cell-in-range:before {
    background: rgba(64, 150, 123, 0.5) !important;
  }
  & .rs-btn-primary:disabled {
    background-color: ${appColor.App.primary} !important;
  }
  & .rs-calendar-table-cell-is-today .rs-calendar-table-cell-content {
    box-shadow: inset 0 0 0 1px ${appColor.App.primary} !important;
  }
  & .rs-calendar-table-cell {
    &:hover {
      .rs-calendar-table-cell-content {
        color: ${appColor.App.primary} !important;
        background: rgba(64, 150, 123, 0.5) !important;
      }
    }
  }
  & .rs-calendar-table-cell-selected-end {
    & .rs-calendar-table-cell-content {
      color: ${appColor.App.white} !important;
      background: ${appColor.App.primary} !important;
    }
  }
  & .rs-calendar-table-cell-selected-start {
    & .rs-calendar-table-cell-content {
      color: ${appColor.App.white} !important;
      background: ${appColor.App.primary} !important;
    }
  }

  & .rs-calendar-month-dropdown-cell-active {
    color: ${appColor.App.primary} !important;
  }
  & .rs-calendar-month-dropdown-year {
    color: ${appColor.App.primary} !important;
    font-weight: bold !important;
  }
  & .rs-calendar-header-title {
    color: ${appColor.App.primary} !important;
    font-weight: bold !important;
  }
  & .rs-calendar-header-title-date {
    color: ${appColor.App.primary} !important;
    font-weight: bold !important;
  }
  & .rs-picker-daterange-header.rs-picker-tab-active-start:after,
  & .rs-picker-daterange-header.rs-picker-tab-active-end:after {
    border-bottom: 2px solid ${appColor.App.primary} !important;
    background-color: transparent !important;
  }

  & .MuiChip-root {
    &:hover {
      background-color: ${appColor.App.primary} !important;
      color: ${appColor.App.white} !important;

      & .MuiChip-deleteIcon {
        color: ${appColor.App.white} !important;
      }
    }
  }
`;
